import React from "react";
import { useTranslation } from "react-i18next"
import './index.scss'
import { useTheme } from "../../../../../customProviders/ThemeProvider"


export const EditFontSize = () => {
  const { t } = useTranslation()
  const themeContext: any = useTheme()

  return (
    <div className="edit-text-size-wrap">
      <p>{t('EDIT_THEME.FONT_SIZE')}</p>
      <div className="buttons-wrapper">
        {themeContext?.magnifiers?.map((magnifier: any) => {
          return (
            <button
              type='button'
              onClick={() => themeContext.setActiveMagnifier(magnifier)}
              key={magnifier.label}
              className={`status-tab-holder ${themeContext.activeMagnifier.label === magnifier.label ? "active" : ''}`}
            >
              {magnifier.label}
            </button>
          )
        })}
      </div>
    </div>
  )
};
